export default __webpack_public_path__ + "static/8-a63cff4b3f5ee3522508210805d98879.webp";